import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { API } from '../../config/api';
import { environment } from '../../../../environments/environment';
import { UserInformationModel, PaginationCustomerUserRequest } from './setting.model';
import { requestQuery } from 'src/@shared/untils';

@Injectable()
export class UserSettingService {
    public baseUrl = environment.baseUrl;
    constructor(
        private _http: HttpClient,
        ) {
        }
    public getUserInfomation(): Observable<any> {
        return this._http.get(this.baseUrl + `${API.CUSTOMER_PORTAL.SETTING.GET_USER_INFORMATION}`);
    }

    public saveUserInfomation(user: UserInformationModel): Observable<any> {
        return this._http.put(this.baseUrl + `${API.CUSTOMER_PORTAL.SETTING.SAVE_USER_INFORMATION}/` + user.id, user);
    }

    public createUser(user: UserInformationModel): Observable<any> {
        return this._http.post(this.baseUrl + `${API.CUSTOMER_PORTAL.SETTING.CREATE_USER}/` + user.id, user);
    }

    public getUsers(request: PaginationCustomerUserRequest): Observable<any> {
        return this._http.get(this.baseUrl + `${API.CUSTOMER_PORTAL.SETTING.SAVE_USER_INFORMATION}?${requestQuery(request)}`);
    }

    public deleteUser(id: string): Observable<any> {
        return this._http.delete(API.USER.DELETE(id));
    }

    public getCurrentBranchUsers(request: PaginationCustomerUserRequest): Observable<any> {
        return this._http.get(this.baseUrl + `${API.CUSTOMER_PORTAL.SETTING.GET_USERS_CURRENT_BRANCH}?${requestQuery(request)}`);
    }
}
